import React, { useEffect } from 'react';

import { useLocation } from 'react-router';

import {
  type HelpCenterRole,
  helpCenterArticle,
  helpCenterHub,
  helpCenterIndex,
} from '@clearverify/constants';

import { FullscreenLoader } from 'src/components/common';
import { useResourcesUserRoleCategory } from 'src/hooks/resources/useResourcesUserRoleCategory';

import {
  type HelpRole,
  isHelpRole,
  resourceCategoryToHelpRole,
} from './utils/resourceCategoryToHelpRole';

function helpCenterOriginFromEnv() {
  const origin = import.meta.env.VITE_APP_HELP_CENTER_ORIGIN;
  return typeof origin === 'string' && origin.length > 0 ? origin : undefined;
}

function parseHelpPath(pathname: string): { role?: HelpRole; slug?: string } {
  const match = pathname.match(/^\/resources\/help\/([^/]+)(?:\/([^/]+))?\/?$/);
  if (!match) return {};
  const role = match[1];
  const slug = match[2];
  if (!isHelpRole(role)) return {};
  return { role, slug };
}

export const ExternalHelpRedirect: React.FC = () => {
  const location = useLocation();
  const { userRoleCategory, loading } = useResourcesUserRoleCategory();
  const userHelpRole = resourceCategoryToHelpRole(userRoleCategory);
  const origin = helpCenterOriginFromEnv();

  useEffect(() => {
    if (loading) return;

    const { role: pathRole, slug } = parseHelpPath(location.pathname);
    const role = (pathRole ?? userHelpRole) as HelpCenterRole | null | undefined;

    let target = helpCenterIndex(origin);
    if (role && slug) {
      target = helpCenterArticle(role, slug, origin);
    } else if (role) {
      target = helpCenterHub(role, origin);
    }

    window.location.replace(target);
  }, [loading, location.pathname, origin, userHelpRole]);

  return <FullscreenLoader />;
};
